// Ana uygulama bileşeni - Routing ve layout yönetimi
import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { useAuth } from './contexts/AuthContext';
import { useTheme } from './contexts/ThemeContext';

// Layout bileşenleri
import Sidebar from './components/Layout/Sidebar';
import Header from './components/Layout/Header';

// Sayfa bileşenleri
import Login from './pages/Auth/Login';
import ForgotPassword from './pages/Auth/ForgotPassword';
import ResetPassword from './pages/Auth/ResetPassword';
import Dashboard from './pages/Dashboard/Dashboard';
import Customers from './pages/Customers/Customers';
import CustomerDetail from './pages/Customers/CustomerDetail';
import Projects from './pages/Projects/Projects';
import ProjectDetail from './pages/Projects/ProjectDetail';
import Offers from './pages/Offers/Offers';
import OfferDetail from './pages/Offers/OfferDetail';
import Reports from './pages/Reports/Reports';
import Users from './pages/Users/Users';
import UserDetail from './pages/Users/UserDetail';
import Settings from './pages/Settings/Settings';
import Profile from './pages/Profile/Profile';

// Loading bileşeni
import LoadingSpinner from './components/Common/LoadingSpinner';

// Ana uygulama içeriği
function AppContent() {
  const { user, loading } = useAuth();
  const { isDarkMode } = useTheme();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Dark mode class'ını body'ye ekle/çıkar
  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDarkMode]);

  // Loading durumunda spinner göster
  if (loading) {
    return <LoadingSpinner />;
  }

  // Kullanıcı giriş yapmamışsa login sayfasına yönlendir
  if (!user) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    );
  }

  // Ana layout - giriş yapmış kullanıcılar için
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header - En üstte tam genişlik */}
      <Header onMenuClick={() => setSidebarOpen(true)} />
      
      <div className="flex">
        {/* Sidebar */}
        <Sidebar 
          isOpen={sidebarOpen} 
          onClose={() => setSidebarOpen(false)} 
        />
        
        {/* Ana içerik alanı */}
        <div className="flex-1 flex flex-col min-h-screen">
          {/* Sayfa içeriği */}
          <main className="flex-1 p-6">
            <Routes>
              {/* Dashboard */}
              <Route path="/" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              
              {/* Müşteri yönetimi */}
              <Route path="/customers" element={<Customers />} />
              <Route path="/customers/:id" element={<CustomerDetail />} />
              
              {/* Proje yönetimi */}
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:id" element={<ProjectDetail />} />
              
              {/* Teklif yönetimi */}
              <Route path="/offers" element={<Offers />} />
              <Route path="/offers/:id" element={<OfferDetail />} />
              
              {/* Raporlar */}
              <Route path="/reports" element={<Reports />} />
              
              {/* Kullanıcı yönetimi (Admin) */}
              <Route path="/users" element={<Users />} />
              <Route path="/users/:id" element={<UserDetail />} />
              
              {/* Ayarlar */}
              <Route path="/settings" element={<Settings />} />
              <Route path="/profile" element={<Profile />} />
              
              {/* 404 - Bulunamayan sayfa */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </main>
        </div>
      </div>
    </div>
  );
}

// Ana App bileşeni
function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;